export default __webpack_public_path__ + "static/media/relatedProgImg2.bf73b8bf.png";